import React, { useState } from 'react';
import styled from 'styled-components';
import { useLocation, useNavigate } from 'react-router-dom';
import { GBAlert } from '@greenbackapp/ui';
import { useAuth } from '../../../contexts/AuthContext';

const DISMISS_KEY = 'business_preview_banner_dismissed';

const BannerWrap = styled.div`
  margin: 16px 24px 0;
`;

/**
 * Announcement introducing the Business preview to Pro subscribers.
 * Shows on every personal page until explicitly dismissed via the ✕;
 * never shows inside /business/* (the PreviewBanner takes over there).
 */
export const BusinessPreviewAnnouncement: React.FC = () => {
  const { isPro } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [dismissed, setDismissed] = useState(
    () => localStorage.getItem(DISMISS_KEY) === '1'
  );

  const dismiss = () => {
    localStorage.setItem(DISMISS_KEY, '1');
    setDismissed(true);
  };

  if (!isPro || dismissed || location.pathname.startsWith('/business')) {
    return null;
  }

  return (
    <BannerWrap>
      <GBAlert
        variant="success"
        title="New for Pro subscribers: Greenback Business preview"
        message="Explore invoicing, banking, accounting, inventory, and reports — a first look at the business experience, built with sample data."
        dismissible
        onDismiss={dismiss}
        action={{
          label: 'Explore the preview',
          onPress: () => navigate('/business'),
        }}
      />
    </BannerWrap>
  );
};

export default BusinessPreviewAnnouncement;
